/**
 * <product-recommendations> — fetches the recommendations section through
 * the Section Rendering API and swaps its own content (Dawn pattern,
 * replaces the live theme's jQuery related-products + Swiper stack).
 *
 * Expects data-url="{routes.product_recommendations_url}?section_id=...
 * &product_id=...&limit=...".
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };
    new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  async loadRecommendations() {
    try {
      const response = await fetch(this.dataset.url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('product-recommendations');
      if (fresh && fresh.innerHTML.trim().length) {
        this.innerHTML = fresh.innerHTML;
      }
    } catch (error) {
      console.error('Product recommendations failed to load:', error);
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
